import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";


export default function header() {
    return (
        <React.Fragment>
        <Navbar collapseOnSelect expand="sm" className="navbar-dark">
            <Container>
                <Navbar.Brand href="https://pulp.ph"><img src={require('../img/PULP.png')} alt="" className="brand-image" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                    </Nav>
                    <Nav>
                        <Nav.Link as={Link} to='/' className="nav-link text-warning h5 mx-4">Home</Nav.Link>
                        <Nav.Link eventKey={2} as={Link} to='Secret-Santa' className="nav-link text-warning h5 mx-4">Secret Santa</Nav.Link>
                        <Nav.Link eventKey={3} as={Link} to='Event-Details' className="nav-link text-warning h5 mx-4">Event Details</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </React.Fragment>
    );
  };